export function setCookie(name, value = '') {
  document.cookie = `${name}=${value};SameSite=Lax`;
}

export function getCookie(name) {
  const [cookie] = document.cookie.split(';').filter((item) => item.indexOf(`${name}=`) >= 0);
  const value = cookie ? cookie.split('=')[1] : '';
  return {
    name,
    value,
  };
}
